import React, { FC } from 'react';
import styled from 'styled-components';
import ContentBaseLayout from '../../../libx/shared/ContentBaseLayout';
import { useTranslation } from 'react-i18next';

const StPartnerFallbackMessage = styled.h2`
    display: flex;
    justify-content: center;
    margin-top: 160px;
`;

export const ProductGroupPartnerFallback: FC = () => {
    const { t } = useTranslation();

    return (
        <ContentBaseLayout
            documentTitle={t('shop.productGroups.titleOverview')}
            contentComponent={
                <StPartnerFallbackMessage>
                    {t('marketing.productGroups.warnings.partnerFallback')}
                </StPartnerFallbackMessage>
            }
        />
    );
};
